import React from 'react';
import cx from 'classnames';

import Avatar1BW from './util/images/BWsafe_1.png';
import Avatar2BW from './util/images/BWsafe_2.png';
import Avatar3BW from './util/images/BWsafe_3.png';
import Avatar4BW from './util/images/BWsafe_4.png';
import Avatar5BW from './util/images/BWsafe_5.png';
import Avatar6BW from './util/images/BWsafe_6.png';
import Avatar7BW from './util/images/BWsafe_7.png';
import Avatar8BW from './util/images/BWsafe_8.png';
import Avatar9BW from './util/images/BWsafe_9.png';
import Avatar10BW from './util/images/BWsafe_10.png';
import Avatar11BW from './util/images/BWsafe_11.png';
import Avatar1 from './util/images/safe_1.png';
import Avatar2 from './util/images/safe_2.png';
import Avatar3 from './util/images/safe_3.png';
import Avatar4 from './util/images/safe_4.png';
import Avatar5 from './util/images/safe_5.png';
import Avatar6 from './util/images/safe_6.png';
import Avatar7 from './util/images/safe_7.png';
import Avatar8 from './util/images/safe_8.png';
import Avatar9 from './util/images/safe_9.png';
import Avatar10 from './util/images/safe_10.png';
import Avatar11 from './util/images/safe_11.png';

interface SafeAvatarProps {
  size: string;
  colorized?: boolean;
  address: string;
  styleWrapper?: string;
  styleImage?: string;
}

const avatarArrColorized = [
  Avatar1,
  Avatar2,
  Avatar3,
  Avatar4,
  Avatar5,
  Avatar6,
  Avatar7,
  Avatar8,
  Avatar9,
  Avatar10,
  Avatar11,
];

const avatarArrBlackWhite = [
  Avatar1BW,
  Avatar2BW,
  Avatar3BW,
  Avatar4BW,
  Avatar5BW,
  Avatar6BW,
  Avatar7BW,
  Avatar8BW,
  Avatar9BW,
  Avatar10BW,
  Avatar11BW,
];

export const SafeAvatar: React.FC<SafeAvatarProps> = ({
  size,
  colorized = true,
  address,
  styleWrapper,
  styleImage,
}) => {
  const avatarArr = colorized ? avatarArrColorized : avatarArrBlackWhite;
  const getIconByAddress = () => {
    if (!Boolean(address)) {
      return avatarArr[0];
    }

    const str = address.replace('0x', '').replace('.', '');
    if (str.length < 5) {
      return avatarArr[
        isNaN(parseInt(str, 16) % avatarArr.length) ? 1 : parseInt(str, 16) % avatarArr.length
      ];
    }

    return avatarArr[
      isNaN(parseInt(str.substring(str.length - 5), 16) % avatarArr.length)
        ? 0
        : parseInt(str.substring(str.length - 5), 16) % avatarArr.length
    ];
  };

  return (
    <div className={cx('flex items-center justify-center rounded-[50%]', styleWrapper)}>
      <img
        src={getIconByAddress()}
        className={cx('max-w-[100%] max-h-[100%]', styleImage)}
        style={{ width: size, height: size }}
        alt=""
      />
    </div>
  );
};
